module.exports = __webpack_public_path__ + "img/addp.c1f84c93.png";